import _ from 'lodash'


export default {
    getCurrentUser: function(state) {
  	// right now switching this to the active_traveler obj
  	// we might need to inspect the obj later for admin, etc
  	return active_traveler
        let user = state.get('currentUser')

        if (_.isNull(user)) { 
            // TODO: is this okay?    	
    	return active_traveler
    	// return undefined 
        }

        return user
    }
}
